/* Diamond Studio — social profile links (2026-09-29), every page.
   The links (Instagram, Facebook) are printed once in <template id="ds-social-template"> from
   snippets/ds-social-links.liquid (via snippets/ds-cro-config.liquid). Copies are placed in:
   1. the footer, as a row under the link columns (the home and product footers are drawn by script after the page
      loads, so this waits for them; the footer on the other pages is already there);
   2. the phone menu, at the end of its first screen;
   3. the desktop top bar, after the currency.
   All of these start off-screen or closed, so nothing visible moves. The links open in a new tab, so the shopper's
   page stays open. Clicks are sent to dataLayer as "ds_social_click" with the network and where it was clicked. */
(() => {
  'use strict';
  if (window.DSSocial) return;
  window.DSSocial = {version: '2026-09-29'};

  const copy = place => {
    const tpl = document.getElementById('ds-social-template');
    const el = tpl?.content.firstElementChild?.cloneNode(true);
    if (!el) return null;
    el.classList.add('ds-social--' + place);
    el.setAttribute('data-ds-social-place', place);
    return el;
  };
  const add = (host, place) => {
    if (!host || host.querySelector('[data-ds-social]')) return;
    const el = copy(place);
    if (el) host.append(el);
  };

  // The home and product footers style their last link column on phones with ":last-child" rules. The row added here
  // becomes the last child, so that column is marked and ds-social.css gives it the same layout.
  function footers() {
    document.querySelectorAll('footer .footer-columns, footer .dsc-footer-columns').forEach(cols => {
      if (cols.querySelector(':scope > [data-ds-social]')) return;
      cols.lastElementChild?.setAttribute('data-ds-social-before', '');
      add(cols, 'footer');
    });
  }
  function menu() {
    add(document.querySelector('#ds-mobile-nav .new-mobile-home'), 'menu');
  }
  function bar() {
    document.querySelectorAll('.shop-utility > span:last-child').forEach(cluster => add(cluster, 'bar'));
  }

  // Listens on window in the capture phase so a handler that stops the click cannot hide it.
  function measure() {
    window.addEventListener('click', event => {
      const link = event.target instanceof Element ? event.target.closest('[data-ds-social-network]') : null;
      if (!link) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'ds_social_click',
        network: link.getAttribute('data-ds-social-network'),
        placement: link.closest('[data-ds-social-place]')?.getAttribute('data-ds-social-place') || ''
      });
    }, true);
  }

  function start() {
    menu();
    bar();
    measure();
    footers();
    // Home and product pages: the footer is drawn into #app after the page loads (and may be drawn again),
    // so keep checking for a short while. Adding the row twice is not possible (see add()).
    const app = document.getElementById('app');
    if (!app) return;
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        footers();
      });
    });
    observer.observe(app, {childList: true, subtree: true});
    setTimeout(() => observer.disconnect(), 20000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
